<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fCanalesProductos" name="nomCanalesProductos">
    <div class="grid form-group">
      <div class="col-12 md:col-12 lg:col-12">
        <div class="div-form">
          <label>* {{ 'CANALESPRODUCTOS.LBL_PRODUCTO' | translate }}</label>
          <p-dropdown disableTab  id="idProducto" name="nomProducto" [options]="lisProductos"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                      filter="filter"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                       formControlName="idProducto"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idProducto.invalid">
            {{ 'CANALES.MSG_MINIMOPRODUCTO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>


  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas"
               [value]="lisCanalesProductos" selectionMode="single" dataKey="idCanalProducto"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.codigoProducto}}</td>
            <td>{{row.nombreProducto}}</td>
            <td>{{row.tipoProductoBancario}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" (onChange)="cambiarHabilitado(row)"></p-checkbox>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-plus" label="{{'BTN_SIGUIENTE' | translate }}"
              type="submit" (click)="irSiguiente()"
              pButton></button>
    </div>
  </div>
</div>


<p-confirmDialog #cd key="productos">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
